<template>
    <main :class="['ps-single-view', `patent-app-view__${selfName}`]" flex="-start">
        <!--content-->
        <div ref="densiOverflow" :class="[CLASS_NAME_APP_CONTENT_VIEW, contentViewClassStatus ]" flex-item="()full">
            <router-view v-bind="{ ...$props, ...innerAttr, patentId }" />
        </div>
        <DensityBar v-if="hasDensity" :overflowBy="$refs.densiOverflow" />
    </main>
</template>

<script>
/*
     ⚠️ 此组件存在的目的仅仅是为了解析左右路由关系 ⚠️
        ⚠️ 请把此组件当成 Functional 组件使用！⚠️
                     🙏
*/
import { pluginsMapByName } from '@/subview_plugins/install';
import DensityBar from 'library-@/components/DensityBar';
import { CLASS_NAME_APP_CONTENT_VIEW } from '@/constants';
import { checkAclByName } from '@/utils/permission';
import { usePermission } from '@/composables/use-permission';

export default {
    name: 'SingleView',
    components: {
        DensityBar,
    },
    props: {
        viewParams: {
            type: Object,
            required: true,
        },
        selfName: {
            type: String,
            required: true,
        },
    },
    setup() {
        const { permissions } = usePermission();

        return {
            permissions,
        };
    },
    computed: {
        innerAttr() {
            const $attrs = { ...this.$attrs };
            delete $attrs.flex;
            delete $attrs['flex-item'];
            return $attrs;
        },
        hasDensity() {
            const plugin = pluginsMapByName.get(this.selfName);
            return plugin && plugin.enableDensity;
        },
        selfHandelPadding() {
            const plugin = pluginsMapByName.get(this.selfName);
            return plugin && plugin.selfHandelPadding;
        },
        contentViewClassStatus() {
            return {
                'patent-app__content-view--no-padding': this.selfHandelPadding,
                'patent-app__content-view--no-density': !this.hasDensity,
            };
        },
        patentId() {
            return this.viewParams.patentId;
        },
    },
    watch: {
        selfName: {
            handler(newVal) {
                if (!checkAclByName(newVal, this.permissions)) this.$router.replace({ path: '/abst', params: { ...this.$route.params }, query: { ...this.$route.query } });
            },
            immediate: true,
        },
    },
    created() {
        this.CLASS_NAME_APP_CONTENT_VIEW = CLASS_NAME_APP_CONTENT_VIEW;
    },
};
</script>
<style lang="scss">
.ps-single-view{
    height: 100%;
    overflow: auto;
    position: relative;
    .patent-app__content-view {
        position: relative;
        height: 100%;
        max-height: 100%;
        padding: 20px 40px 20px 20px;
        overflow: auto;
        background-color: #fff;
        &--no-density {
            padding: 20px;
        }
        &--no-padding {
            padding: 0;
        }
    }
    .density-bar{
        top:0;
        bottom: 0;
        right: 18px;
    }
}
</style>
